module.exports = __webpack_public_path__ + "img/nbe_logo.60604365.png";